export default "__VITE_ASSET__a6ce1f22__"